import React from 'react';
import { AppBar, Box, Button, Chip, Stack, Toolbar, Typography } from '@mui/material';
import { LogoutRounded, PersonRounded, StorefrontRounded, WifiOffRounded, WifiRounded } from '@mui/icons-material';

export default function NavbarPos({ usuario, cajaAbierta, cajaId, conectado, onCaja, onSalir }) {
  const nombre = usuario?.name || usuario?.nombre || usuario?.email || 'Usuario';

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        background: 'linear-gradient(105deg, #173b63 0%, #123255 52%, #0f2948 100%)',
        borderBottom: '1px solid rgba(255,255,255,.08)',
        boxShadow: '0 8px 24px rgba(17, 48, 82, .16)',
      }}
    >
      <Toolbar
        sx={{
          minHeight: '72px !important',
          px: { xs: 1.5, sm: 2, md: 2.5 },
          gap: 1.5,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1.1} sx={{ flexShrink: 0, minWidth: 0 }}>
          <Box
            component="img"
            src="/favicon-128.png"
            alt="IntegraNube PDV"
            sx={{
              width: { xs: 46, md: 52 },
              height: { xs: 46, md: 52 },
              display: 'block',
              objectFit: 'contain',
              flexShrink: 0,
              filter: 'drop-shadow(0 4px 8px rgba(0,0,0,.14))',
            }}
          />

          <Stack direction="row" spacing={0.7} alignItems="baseline" sx={{ display: { xs: 'none', sm: 'flex' }, whiteSpace: 'nowrap' }}>
            <Typography
              component="div"
              sx={{
                color: '#fff',
                fontSize: { sm: 22, md: 25 },
                lineHeight: 1,
                fontWeight: 950,
                letterSpacing: '-.7px',
              }}
            >
              IntegraNube
            </Typography>
            <Typography
              component="div"
              sx={{
                color: '#3d9cff',
                fontSize: { sm: 18, md: 21 },
                lineHeight: 1,
                fontWeight: 950,
                letterSpacing: '-.4px',
              }}
            >
              PDV
            </Typography>
          </Stack>
        </Stack>

        <Box sx={{ flex: 1 }} />

        <Stack direction="row" spacing={{ xs: 0.55, sm: 0.8 }} alignItems="center" sx={{ minWidth: 0 }}>
          <Chip
            icon={conectado ? <WifiRounded /> : <WifiOffRounded />}
            label={conectado ? 'Online' : 'Sin conexión'}
            variant="outlined"
            sx={{
              display: { xs: 'none', md: 'flex' },
              height: 34,
              color: conectado ? '#69e6c1' : '#fecaca',
              borderColor: conectado ? 'rgba(105,230,193,.44)' : 'rgba(254,202,202,.45)',
              bgcolor: conectado ? 'rgba(16,185,129,.08)' : 'rgba(239,68,68,.08)',
              fontWeight: 850,
              '& .MuiChip-icon': { color: 'inherit' },
            }}
          />

          <Chip
            icon={<StorefrontRounded />}
            label={cajaAbierta ? (cajaId ? `Caja #${cajaId} abierta` : 'Caja abierta') : 'Caja cerrada'}
            variant="outlined"
            clickable={Boolean(onCaja)}
            onClick={onCaja}
            sx={{
              height: 36,
              color: '#fff',
              borderColor: cajaAbierta ? 'rgba(89,162,255,.65)' : 'rgba(255,255,255,.24)',
              bgcolor: cajaAbierta ? 'rgba(37,99,235,.18)' : 'rgba(255,255,255,.06)',
              fontWeight: 850,
              cursor: onCaja ? 'pointer' : 'default',
              '& .MuiChip-icon': { color: cajaAbierta ? '#7db7ff' : '#d5e0ec' },
              '&:hover': { bgcolor: cajaAbierta ? 'rgba(37,99,235,.26)' : 'rgba(255,255,255,.10)' },
            }}
          />

          <Stack
            direction="row"
            spacing={0.75}
            alignItems="center"
            sx={{
              display: { xs: 'none', lg: 'flex' },
              pl: 0.65,
              pr: 0.3,
              minWidth: 0,
            }}
          >
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: '50%',
                display: 'grid',
                placeItems: 'center',
                bgcolor: 'rgba(255,255,255,.10)',
                border: '1px solid rgba(255,255,255,.12)',
              }}
            >
              <PersonRounded sx={{ color: '#dbe9f8', fontSize: 19 }} />
            </Box>
            <Typography variant="body2" fontWeight={850} noWrap sx={{ maxWidth: 170, color: '#f5f8fc' }}>
              {nombre}
            </Typography>
          </Stack>

          <Button
            onClick={onSalir}
            startIcon={<LogoutRounded />}
            sx={{
              color: '#ffb4b4',
              fontWeight: 900,
              minWidth: { xs: 44, sm: 82 },
              px: { xs: 0.8, sm: 1.1 },
              '& .MuiButton-startIcon': { mr: { xs: 0, sm: 0.7 } },
              '&:hover': { bgcolor: 'rgba(239,68,68,.10)' },
            }}
          >
            <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Salir</Box>
          </Button>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
